export enum AVATAR_SIZES {
  md = 'md',
  sm = 'sm',
  xs = 'xs',
  xl = 'xl',
}
